import React__default from 'react';

const NewResourceContext = /* @__PURE__ */ React__default.createContext({});
const useNewResourceContext = () => React__default.useContext(NewResourceContext);

export { NewResourceContext, useNewResourceContext };
//# sourceMappingURL=ModalNewResourceContext.js.map
